import React, { FC } from 'react';
import { Link as ReactLink } from 'react-router';

import moment from 'moment';

import Typography from '@mui/material/Typography';

import footerLogo from '@assets/logos/logo.png';

import Container from '@components/common/Container';

import { PATH_INDEX } from '@constants/common/routes.constants';

import useStyles from './styles.module';

const CURRENT_YEAR = moment().year();

const Footer: FC = () => {
  const { classes } = useStyles();

  return (
    <footer className={classes.footer}>
      <Container className={classes.box}>
        <div className={classes.left}>
          <ReactLink to={PATH_INDEX}>
            <img
              src={footerLogo}
              className={classes.logo}
              alt="logo dexFinance"
            />
          </ReactLink>
        </div>
        <div className={classes.right}>
          {/* Per client: no social media for Sky — socials removed. */}
          {/* Sky figma: copyright is Body3 (Poppins 14/400), white */}
          <Typography
            variant="body3"
            color={(theme) => theme.palette.custom.text.white}
          >
            © {CURRENT_YEAR} Sky Bonds. All rights reserved.
          </Typography>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
